import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
  subtitle: {
    marginBottom: 16,
  },
  queueDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    display: "inline-block",
    marginRight: 8,
    flexShrink: 0,
    verticalAlign: "middle",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
  },
}));

const SelectQueueOnAcceptModal = ({ open, onClose, onConfirm, userQueues }) => {
  const classes = useStyles();
  const [selectedQueueId, setSelectedQueueId] = useState("");

  useEffect(() => {
    if (open && userQueues?.length > 0) {
      setSelectedQueueId(userQueues[0].id);
    }
  }, [open, userQueues]);

  const handleConfirm = () => {
    onConfirm(selectedQueueId);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{i18n.t("tickets.selectQueueModal.title")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" className={classes.subtitle}>
          {i18n.t("tickets.selectQueueModal.subtitle")}
        </Typography>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel shrink>{i18n.t("ticketsList.filters.none")}</InputLabel>
          <Select
            value={selectedQueueId}
            onChange={(e) => setSelectedQueueId(e.target.value)}
            label={i18n.t("ticketsList.filters.none")}
          >
            {(userQueues || []).map((q) => (
              <MenuItem key={q.id} value={q.id} className={classes.menuItem}>
                <span
                  className={classes.queueDot}
                  style={{ backgroundColor: q.color || "#757575" }}
                />
                {q.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {i18n.t("tickets.selectQueueModal.cancel")}
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={!selectedQueueId}
        >
          {i18n.t("tickets.selectQueueModal.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectQueueOnAcceptModal;
